import CheckMark from './CheckMark.vue';

export const icons = {
    CheckMark,
};

export default icons;
